import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Modal2Service } from '@app/core/services/modal/modal2.service';
import { UserService } from '@app/core/services/user/user.service';
import { WarningService } from '@app/core/services/warning/warning.service';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { NavParams } from '@ionic/angular';
import { updatePassword } from 'aws-amplify/auth';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-user-account-settings-modal2-password',
    templateUrl: './user-account-settings-modal2-password.component.html',
    styleUrls: ['./user-account-settings-modal2-password.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserAccountSettingsModal2PasswordComponent {
    header: string = '';
    currentEmail: string = '';
    currentPassword: string = '';
    newPassword: string = '';
    newPasswordConfirm: string = '';

    passwordGoodLength: boolean;
    passwordGoodLower: boolean;
    passwordGoodUpper: boolean;
    passwordGoodSymbol: boolean;

    faCheckCircle = faCheckCircle;

    constructor(navParams: NavParams, private warningService: WarningService, private userService: UserService, private modal2Service: Modal2Service) {
        this.currentEmail = navParams.get('email');
    }

    async submit() {
        if (
            this.passwordGoodLength &&
            this.passwordGoodLower &&
            this.passwordGoodUpper &&
            this.passwordGoodSymbol &&
            this.newPassword === this.newPasswordConfirm
        ) {
            try {
                await updatePassword({ oldPassword: this.currentPassword, newPassword: this.newPasswordConfirm });
                this.modal2Service.toast('Successfully Updated Password');
                this.dismiss();
            } catch (error) {
                console.log('asdfsaf', error);
                this.warningService.create(error.message);
            }
        }
    }

    recheckPassword() {
        // check length
        this.passwordGoodLength = this.newPassword.length >= 8;

        // check lower
        this.passwordGoodLower = this.newPassword.match(/[a-z]/) !== null;

        // check upper
        this.passwordGoodUpper = this.newPassword.match(/[A-Z]/) !== null;

        // check symbol
        this.passwordGoodSymbol = this.newPassword.match(/[0-9\[\]{}\(\)?\-“!@#%&/,><\':;|_~]/) !== null;
    }

    dismiss() {
        this.modal2Service.dismiss();
    }

    requestPasswordChange() {
        this.userService.cognitoSendResetEmail(this.currentEmail).subscribe((response: any) => {
            if (parseInt(response.statusCode, 10) === 401) {
                this.warningService.create(response.body);
            } else {
                this.warningService.create('Check your email ' + this.currentEmail + ' for a reset password link.');
            }
        });
    }
}
